export default "__VITE_ASSET__Dvwdg$q$__"